import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useNetwork = () => useQuery({ queryKey: [`network`], queryFn: async () => {
    const callback = await API.get(`/network`)
    return callback?.data
}, staleTime: 1000 * 60 * 60 * 12, gcTime: 1000 * 60 * 60 * 24 * 7 })

export default useNetwork